<template>
    <!-- 时序图下面的时间坐标轴 -->
  <div>
   <div v-for="(vuele,name,index) in dayTime" :key="index" style="float:left;width:12%;">
       {{dayTime[name]}}
   </div>
   <div style="float:right">
       24:00
   </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            dayTime: {
                a: '0:00',
                b: '3:00',
                c: '6:00',
                d: '9:00',
                e: '12:00',
                f: '15:00',
                g: '18:00',
                h: '21:00'
            },
            daynum: [1, 2, 3, 4, 5, 6, 7, 8]
        }
    }
}
</script>

<style>

</style>
